import { IGroupTaskResource } from "../../group-tasks";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { GroupTaskStatus } from "../types";

export type IGroupTaskEditMutationParameters = {
    task: RelationalValue<IGroupTaskResource>;
    title?: string;
    description?: string;
    status?: GroupTaskStatus;
};

export type IGroupTaskUpdateMutationResult = IGroupTaskResource;

export const groupTaskEditMutation: IApiMutationFunction<IGroupTaskEditMutationParameters> = ({
    task,
    title,
    description,
    status,
    ...data
}) => {
    return {
        method: "PUT",
        url: `/group_tasks/${mapRelationalValue(task)}`,
        data: {
            ...data,
            title,
            description,
            status,
        },
    };
};

export const useGroupTaskEditMutation = createApiMutationHook<
    IGroupTaskEditMutationParameters,
    IGroupTaskUpdateMutationResult
>(groupTaskEditMutation);
